module.exports = __webpack_public_path__ + "img/tether.e80e3338.png";